import {
  CHILD_PRICE_RATIO,
  DEFAULT_ADMIN_FEE,
  INFANT_PRICE_RATIO,
} from "./pricingDefaults";

export const parseAmount = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

/** Matches existing Pricing.jsx net display (base minus admin %). */
export const calculateNetReceive = (basePrice, adminFeePercent) => {
  const base = parseAmount(basePrice);
  const fee = parseAmount(adminFeePercent);
  const feeAmount = (base * fee) / 100;
  return Math.round((base - feeAmount) * 100) / 100;
};

export const deriveChildPrice = (adultPrice) =>
  Math.round(parseAmount(adultPrice) * CHILD_PRICE_RATIO * 100) / 100;

export const deriveInfantPrice = (adultPrice) =>
  Math.round(parseAmount(adultPrice) * INFANT_PRICE_RATIO * 100) / 100;

export const resolvePaxPrice = (adultPrice, storedPrice, ratio) => {
  if (storedPrice !== "" && storedPrice !== null && storedPrice !== undefined) {
    return parseAmount(storedPrice);
  }
  return Math.round(parseAmount(adultPrice) * ratio * 100) / 100;
};

export const buildBasePricePayload = ({
  packageId,
  categoryId,
  stayCategoryId,
  adultPrice,
  childPrice,
  infantPrice,
  adminFee = DEFAULT_ADMIN_FEE,
}) => ({
  package_id: packageId,
  package_stay_category_id: categoryId,
  stay_category_id: stayCategoryId,
  adult_price: parseAmount(adultPrice),
  child_price: parseAmount(childPrice),
  infant_price: parseAmount(infantPrice),
  adult_commission: adminFee,
  child_commission: adminFee,
  infant_commission: adminFee,
});

export const computeDepositPreview = (sellingPrice, depositPercent) => {
  const total = parseAmount(sellingPrice);
  const pct = Math.min(100, Math.max(0, parseAmount(depositPercent)));
  const now = Math.round(((total * pct) / 100) * 100) / 100;
  const remaining = Math.round((total - now) * 100) / 100;
  return { now, remaining, percent: pct };
};

export const computePricingCompletion = ({
  hasBasePrice,
  hasSeasonalOrNormal,
  paymentConfigured,
}) => {
  let score = 0;
  if (hasBasePrice) score += 50;
  if (hasSeasonalOrNormal) score += 25;
  if (paymentConfigured) score += 25;
  return score;
};
